import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useCallback } from 'react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { Heading, HeadingLevel } from '../../../../subcomponents/heading';
import { Icon } from '../../../../subcomponents/icon/icon';
import { Link } from '../../../../subcomponents/link/link';
const b = bemClassBuilder('v-film-custom-action-list-action');
export const FilmCustomActionListAction = props => {
    const i18n = useI18n();
    const { customAction, film } = props;
    const { iconName, message, title, href, onClick } = customAction;
    const handleClick = useCallback(() => {
        onClick === null || onClick === void 0 ? void 0 : onClick(film);
    }, [onClick, film]);
    return (_jsxs(Link, Object.assign({ className: b.block(), href: href, onClick: onClick && handleClick }, { children: [iconName && (_jsx("div", Object.assign({ className: b.element('icon-wrapper') }, { children: _jsx(Icon, { className: b.element('icon'), name: iconName }) }))), _jsxs("div", Object.assign({ className: b.element('details') }, { children: [_jsx(Heading, Object.assign({ className: b.element('heading'), level: HeadingLevel.H5 }, { children: i18n.translatable(title) })), message && _jsx("p", Object.assign({ className: b.element('message') }, { children: i18n.translatable(message) }))] }))] })));
};
FilmCustomActionListAction.displayName = 'FilmCustomActionListAction';
